import { AppConfig } from ".";

export const prodConfig: AppConfig = {
    apiUrl: 'https://mss-prod-app.azurewebsites.net',
    dashboardUrl: 'https://dashboard.mysportset.com',
    firebaseConfig: {
        apiKey: "AIzaSyAr9S5r5ETSBi1iA79nQ8kV-QuupgA5TRE",
        authDomain: "mss-prod-admin.firebaseapp.com",
        projectId: "mss-prod-admin",
        storageBucket: "mss-prod-admin.firebasestorage.app",
        messagingSenderId: "189776316808",
        appId: "1:189776316808:web:e6193221ab6829ff54523d",
    },
    sentryConfig: {
        dsn: 'https://35ba1ee64b851d42c40e829c4c8cb2fd@o4508978380341248.ingest.de.sentry.io/4509043064111184',
        tracesSampleRate: 1
    },
    posthogConfig: {
        apiKey: 'phc_A9X6tX9GPzFjnqyZLLhwhY3J8nSmCEbbTiADhj9wm2N',
        host: 'https://ph.mysportset.com'
    },
    // Already onboarded by hand — no Accueil video / guided tour (2026-11-03).
    onboardingGuidesHiddenForOrganizationIds: [
        'a3ca81dc-ef02-4661-986a-1026ca03ebaf', // Frejus
        '8459d502-234b-474a-a661-151f19f1bea9', // RoyalPadel
        'c7261110-0e7f-4b89-99dd-8a5fc482912a', // DynamicSports
    ],
};